import React from "react";
import { usePaymentContext } from "lib/contexts/PaymentProvider";
import { useSubscriptionContext } from "lib/contexts/SubscriptionProvider";
import { useLocale } from "lib/hooks/useLocale";
import { Info } from "@phosphor-icons/react";

const SubscriptionPaymentNotice: React.FC = () => {
  const { t } = useLocale();
  const {
    state: { mode, isSwitching, isEligible },
    actions: { setMode },
  } = useSubscriptionContext();
  const {
    state: { paymentMethods },
  } = usePaymentContext();

  if (!isEligible || mode !== "SUBSCRIBE" || paymentMethods?.length) return null;

  return (
    <div className="border-base mb-3 flex flex-col gap-2 bg-white p-3">
      <div className="flex items-start gap-2">
        <Info className="mt-0.5 h-4 w-4 shrink-0 text-coal-light" weight="duotone" />
        <p className="text-text-xs-regular text-coal-medium">{t("subscription_no_payment_mode")}</p>
      </div>
      <button
        id="subscription-switch-to-pay-once"
        disabled={isSwitching}
        onClick={() => setMode("PAY_ONCE")}
        className="self-start text-text-xs-semibold text-primary-dark underline underline-offset-2 disabled:opacity-50">
        {t("subscription_switch_to_pay_once")}
      </button>
    </div>
  );
};

export default SubscriptionPaymentNotice;
